import React from "react";

import copanLogo from "../../assets/logo_copan.webp";

import "./header.styles.css";

const Header = () => {
    return (
        <>
            <div className='header'>
                <div className='header-logo-box'>
                    <img
                        className='header-logo-box-img'
                        src={copanLogo}
                        alt='logo copan'
                    />
                </div>
            </div>
            <div className='subHeader'>
                <h3 className='title'>
                    Proveedores - consulta de ordenes de pago
                </h3>
            </div>
        </>
    );
};

export default Header;
